/**
 * scrollSyncHorizontal syncs the scroll bar horizontally for two equally sized elements.
 *
 * @param {string} scroller - ID for scrolling element
 * @param {string} syncer - ID for element to sync scroll with
 */
function scrollSyncHorizontal(scroller, syncer) {
   const scrollerEle = document.getElementById(scroller);
   const syncerEle = document.getElementById(syncer);
   if (syncerEle) {
      syncerEle.scrollLeft = scrollerEle.scrollLeft;
   }
}

/**
 * scrollSyncVertical syncs the scroll bar vertically for two equally sized elements.
 *
 * @param {string} scroller - ID for scrolling element
 * @param {string} syncer - ID for element to sync scroll with
 */
function scrollSyncVertical(scroller, syncer) {
   const scrollerEle = document.getElementById(scroller);
   const syncerEle = document.getElementById(syncer);
   if (syncerEle) {
      syncerEle.scrollTop = scrollerEle.scrollTop;
   }
}

export { scrollSyncHorizontal, scrollSyncVertical };
